import {Record} from 'immutable';

/** A topic. Used by triggers. */
export default class FilterWord extends Record({
  id: undefined,
  word: null,
}) {}
